module.exports = require("@web3auth/phantom-adapter");